import React from "react";

import Banner from "../../assets/hero.svg";

function Hero() {
  return (
    <div className="pt-[120px]">
      <img src={Banner} />
    </div>
  );
}

export default Hero;
